/* eslint-disable max-params, no-param-reassign -- these linting errors come up constantly with reducers */

import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { RootState } from "@/store";
import { useAppDispatch } from "@/store/hooks";
import { extraReducersFactory } from "@/store/reducers/reset";

interface WaitingRoomData {
  assessmentId: string;
  endDate: string;
  eventId: string;
  eventTitle: string;
  hasMore: boolean;
  isGroupClass: boolean;
  patientId: string;
  startDate: string;
  timeRange: string;
}

interface WaitingRoomModalSliceState {
  waitingRoomData?: WaitingRoomData;
}

const initialState: WaitingRoomModalSliceState = {
  waitingRoomData: undefined,
};

const waitingRoomModalSlice = createSlice({
  extraReducers: extraReducersFactory(initialState),
  initialState,
  name: "waitingRoomModal",
  reducers: {
    resetWaitingRoomData: (state) => {
      state.waitingRoomData = undefined;
    },
    setWaitingRoomData: (state, action: PayloadAction<WaitingRoomData>) => {
      state.waitingRoomData = action.payload;
    },
  },
});

const {
  resetWaitingRoomData: resetWaitingRoomDataAction,
  setWaitingRoomData: setWaitingRoomDataAction,
} = waitingRoomModalSlice.actions;

const selectWaitingRoomData = (state: RootState) =>
  state.waitingRoomModal.waitingRoomData;

const useWaitingRoomModalDispatch = () => {
  const dispatch = useAppDispatch();

  const resetWaitingRoomData = () => {
    dispatch(resetWaitingRoomDataAction());
  };

  const setWaitingRoomData = (data: WaitingRoomData) => {
    dispatch(setWaitingRoomDataAction(data));
  };

  return {
    resetWaitingRoomData,
    setWaitingRoomData,
  };
};

export type { WaitingRoomData, WaitingRoomModalSliceState };
export {
  resetWaitingRoomDataAction,
  selectWaitingRoomData,
  setWaitingRoomDataAction,
  useWaitingRoomModalDispatch,
};
export default waitingRoomModalSlice.reducer;
